import React, { useState, useEffect, FC } from "react";
import styles from "./webToMobileModal.module.scss";
import QRCode from "react-qr-code";
import { _handleError } from "./scanViewErrorHandlerHelper";
import Spinner from "react-spinkit";
import { IndicatorOptions } from "./scanview.types";
import { GlobalLogger } from "./debugLogger";
import { useGlobalContext } from "./ScanViewerContext";

type WebToMobileTexts = {
  modalTitle: string;
  modalText: string;
  buttonText: string;
};

export type WebToMobileHandOffConfig = {
  enabled?: boolean;
  urlBase?: string;
  companyName?: string;
  modalTitle?: string;
  modalText?: string;
  buttonText?: string;
};

export type WebToMobileModalProps = {
  enableModel: boolean;
  cardScanApi: any;
  webToMobileHandoffConfig?: WebToMobileHandOffConfig;
  spinnerOptions: IndicatorOptions;
  backsideSupport?: boolean;
};

const WebToMobileModal: FC<WebToMobileModalProps> = ({
  enableModel,
  cardScanApi,
  webToMobileHandoffConfig,
  spinnerOptions,
  backsideSupport,
}) => {
  const [webToMobileLink, setWebToMobileLink] = useState("");
  const [webToMobileTexts, setWebToMobileTexts] = useState<WebToMobileTexts>({
    modalTitle: "Scanning Failed",
    modalText:
      "Please scan this QR Code to continue scanning on your mobile phone.\nReturn here once successful to continue.",
    buttonText: "Try again",
  });
  const { handleRetryButton } = useGlobalContext();

  useEffect(() => {
    if (
      enableModel &&
      cardScanApi.current.sessionToken &&
      webToMobileHandoffConfig
    ) {
      cardScanApi?.current
        ?.generateMagicLink()
        .then((res: any) => {
          const backside = !!backsideSupport;

          setWebToMobileLink(
            `${webToMobileHandoffConfig?.urlBase}/?token=${res.data.token}&companyName=${webToMobileHandoffConfig?.companyName}&backsideSupport=${backside}`
          );
        })
        .catch((error: any) => {
          GlobalLogger.error(`Error generating magic link - ${error}`);
          //_handleError(error, stateMachineSend, onError);
        });
    }
  }, [enableModel, cardScanApi, webToMobileHandoffConfig, backsideSupport]);

  useEffect(() => {
    const texts = {
      ...(webToMobileHandoffConfig?.modalText
        ? { modalText: webToMobileHandoffConfig.modalText }
        : {}),
      ...(webToMobileHandoffConfig?.modalTitle
        ? { modalTitle: webToMobileHandoffConfig.modalTitle }
        : {}),
      ...(webToMobileHandoffConfig?.buttonText
        ? { buttonText: webToMobileHandoffConfig.buttonText }
        : {}),
    };

    if (Object.keys(texts).length) {
      setWebToMobileTexts((prev) => ({
        ...prev,
        ...texts,
      }));
    }
  }, [webToMobileHandoffConfig]);

  if (!enableModel) {
    return <></>;
  }

  return (
    <div className={styles.scanErrorModal}>
      <h2 className={styles.scanErrorTitle}>{webToMobileTexts.modalTitle}</h2>
      <p className={styles.modalText}>{webToMobileTexts.modalText}</p>
      <div style={{ height: "auto", margin: "20px auto", width: "400" }}>
        {webToMobileLink ? (
          <QRCode
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={webToMobileLink}
            viewBox={`0 0 256 256`}
          />
        ) : (
          <div className={styles.spinnerWrapper}>
            <Spinner {...spinnerOptions} />
          </div>
        )}
      </div>

      <div className={styles.scanErrorButtonContainer}>
        <button
          className={`${styles.scanErrorButton} ${styles.scanErrorButtonPrimary}`}
          onClick={handleRetryButton}
        >
          {webToMobileTexts.buttonText}
        </button>
      </div>
    </div>
  );
};

export default WebToMobileModal;
